import AuthenticatedRoute from 'eflex/util/authenticated-route';

export default class BiSerialNumberReportRoute extends AuthenticatedRoute {
  resetController(controller, isExiting) {
    if (isExiting) {
      controller.selectedSerial = null;
    }
  }
}
